'use strict';
/**
 *  Load modules
 */
//require('./modules/tiny.js');

require('./modules/fancybox.js');

require('./modules/slick.min.js');

import '../scss/app.scss';
import functions from './modules/functions.js';
$(document).ready(function () {
  functions();
});